import React, { Component } from "react";
import "./style.scss";
import { ConsumerDefault } from "./../../../context/Provider";
import ProgressBar from "./../../../components/ProgressBar";

class LayoutDefault extends Component {
  render() {
    const { renderButtom, className, children } = this.props;

    return (
      <>
        <ConsumerDefault>
          {props => {
            return <ProgressBar {...props} />;
          }}
        </ConsumerDefault>
        <div className={`container layoutDefault ${className ? className : ""}`}>
          {children}
          {renderButtom()}
        </div>
      </>
    );
  }
}

export default LayoutDefault;
